'use client'

import useAppStore from '@/core/stores/app';
import { useAuthenticationModalStore, useAuthenticationStore } from "@/core/stores/auth";
import { useUserStore } from '@/core/stores/user';
import { faChevronLeft, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence } from "framer-motion";
import Cookies from "js-cookie";
import Image from "next/image";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";
import { createPortal } from 'react-dom';
import GoogleIcon from "../illustratores/GoogleIcon";
import NextLink from "../NextLink";
import Modal from '../ui/Modal';
import LoginForm from "./loginForm";
import VerificationCodeForm from "./VerificationCodeForm";
import useNextRouter from '@/hooks/useNextRouter';

export default function AuthModal({ baseApi, }: { baseApi: string, }) {
    const router = useRouter()
    const nextRouter = useNextRouter()
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const { showAuthModal, setShowAuthModal } = useAuthenticationModalStore()
    const { setCallBackUrl } = useAuthenticationStore()
    const [showCodeInput, setShowCodeInput] = useState(false)
    const { setPopUpStatus } = useAppStore()

    useEffect(() => {
        setPopUpStatus({ authModal: showAuthModal })
    }, [showAuthModal])


    const createQueryString = useCallback(
        () => {
            const params = new URLSearchParams(searchParams.toString())
            return params.toString()
        },
        [searchParams]
    )

    const handleLogin = async () => {

        const clientToken = Cookies.get('ct');
        const callbackUrl = pathname + '?' + createQueryString();

        setCallBackUrl(callbackUrl);


        Cookies.set('callbackUrl', callbackUrl, { expires: 0.02 });

        nextRouter.push(
            `${baseApi}/user/auth/google?clientToken=${clientToken}${referralCode ? `&referralCode=${referralCode}` : ''
            }`
        );

    };

    const [isReady, setIsReady] = useState(false)
    const { setUserProfile } = useUserStore()
    const { referralCode } = useAppStore()

    async function hadnleOnSubmit() {

    }

    useEffect(() => {
        if (typeof window !== 'undefined' && document) {
            setIsReady(true)
        }
    }, [])

    return isReady && (
        createPortal(<AnimatePresence>
            {showAuthModal && (
                <>

                    <Modal maxWidth='md:max-w-lg' identifier='auth' show={showAuthModal} isFull onClose={() => setShowAuthModal(false)} >
                        <div className="relative flex flex-row justify-between items-center pb-8">
                            {showCodeInput ? <button onClick={() => setShowCodeInput(false)} className="px-2">
                                <FontAwesomeIcon icon={faChevronLeft} className="text-gray-400" />
                            </button> : <span></span>}
                            <div className="w-full flex justify-center">
                                <NextLink href={"/"} className="font-semibold sm:text-2xl flex items-center gap-2">

                                    <Image className='rounded w-9' width={300} height={300} alt='planingo' src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/294831b9-b06f-49c3-b532-755dd9b2ab98-planingo.png`} />
                                    <span className='font-bold flex'>Planin<span className='text-primary-600 w-4 block tracking-tighter font-bold'> Go</span></span>
                                </NextLink>
                            </div>
                        </div>
                        {!showCodeInput ?
                            <>
                                <div className="pb-4">
                                    <h4 className="font-semibold text-xl text-gray-900 pb-2">{`Let's Get Started`}</h4>
                                    <p className="font-medium text-sm text-neutral-500 pb-6">Sign in to manage reservations and explore hotel deals.</p>
                                    <button
                                        onClick={handleLogin}
                                        type="button"
                                        className={`bg-white w-full rounded-xl py-2.5 text-sm text-neutral-600 shadow flex flex-row justify-center items-center gap-2`}
                                    >
                                        <GoogleIcon className="w-5 h-5" />
                                        <span > Sign in with Google </span>
                                    </button>
                                </div>
                                <div className="relative w-full flex justify-center">
                                    <div className="absolute top-3 translate-y-1/2 bg-neutral-200 h-0.5 w-full"></div>
                                    <p className="h-full bg-gray-50 z-10 px-2 text-base text-neutral-500">
                                        or
                                    </p>
                                </div>
                                <LoginForm apiUrl={baseApi} setShowCodeInput={setShowCodeInput} />
                            </> :
                            <VerificationCodeForm onSubmit={hadnleOnSubmit} setShowCodeInput={setShowCodeInput} />
                        }
                    </Modal>
                </>
            )}
        </AnimatePresence>, window.document.body)
    )
}
